// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NNKg","right":"styles_right__3zHhy"};